import { defineMessages } from 'react-intl';

export const i18n: {
	leadStatusFilterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	leadStatusFilterNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	leadStatusFilterLabel: {
		id: 'search-page.salesforce.filter.leadStatus',
		defaultMessage: 'Lead Status',
		description: 'Label for filtering Salesforce leads by their status',
	},
	leadStatusFilterNoOptions: {
		id: 'search-page.salesforce.filter.leadStatus.no-options',
		defaultMessage: 'No lead statuses available',
		description:
			'Message shown in the Salesforce lead status filter dropdown when no status options are available',
	},
});
